/* eslint-disable react/jsx-no-comment-textnodes */


import {DNA, DNAProvider} from "@dna/react";
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import {ApplicationLayout} from './AppLayout';
import { StylesProvider } from "@material-ui/styles";
import {createGenerateClassName} from "@material-ui/core/styles";
import {CssBaseline} from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import {RegisterUser} from "./features/register-user/RegisterUser";
import {Logout} from "./features/register-user/Logout";
import { useContext } from "react";
import { Bootstrapper } from "./Bootstrapper";
import { SelectOrganisationError } from "./features/splash-screen/SelectOrganisationError";
import { useState } from "react";
import {IdentityContext, UserInfo} from "./features/auth/UserIdentity";
import { AuthContext } from "./features/auth/AuthContext";
import { configureFetch } from "./features/auth/AuthenticatedService";
import { GlobalSnackbar } from "@communicare/medications/Shared/GlobalSnackbar";
import {ErrorAccessDenied} from './features/splash-screen/ErrorAccessDenied';
import { Relogin } from "./features/relogin/Relogin";

const generateClassName = createGenerateClassName({
    disableGlobal: true
});

//Slowly move all overrides to material CSS in the theme 
// to eliminate local overrides and provide a consistent look and feel
const theme = createTheme({
    overrides:{
        MuiInputLabel:{
            asterisk:{
                color:"red"
            }
        },
        MuiListItem:{
            gutters:{
                paddingLeft:11,
                paddingRight:11,
                paddingTop:2,
                paddingBottom:2
            }
        },
        MuiListSubheader:{
            root:{
                fontWeight: DNA.tokens.font.weight.semiBold,
                fontSize: 12,
                textTransform: "uppercase",
                color:"unset",
                lineHeight:"20px",
                paddingTop:"20px"
            },
            gutters:{
                paddingLeft:11,
                paddingRight:11
            }
        },
        MuiButton:{
            root:{
                borderRadius:0,
                fontSize:14,
                fontWeight:400,
                lineHeight:"20px",
                textTransform:"unset",
                minHeight:"40px"
            },
            containedPrimary:{
                backgroundColor:"#008381",
                "&:hover":{
                    backgroundColor:"#008381"
                }
            },
            outlinedPrimary:{
                color:"#008381",
                borderColor:"#008381",
                borderWidth:1,
                borderStyle:"solid",
                "&:hover":{
                    backgroundColor:"#008381",
                    color:"#ffffff"
                }
            },
            contained:{
                backgroundColor:"unset",
                borderColor:"#e1e1e1",
                borderWidth:1,
                borderStyle:"solid",
                "&:hover":{
                    backgroundColor:"#008381",
                    color:"#ffffff"
                }
            }
        },
        MuiDialogTitle:{
            root:{
                fontSize:"20px",
                fontWeight:600,
                lineHeight: "28px"
            }
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
        }
    },
    typography: {
        fontFamily: [
            '"Source Sans Pro"'
            , '-apple-system'
            , 'system-ui'
            , '-apple-system'
            , 'Segoe UI'
            , 'Roboto'
            , 'Ubuntu'
            , 'Cantarell'
            , 'Noto Sans'
            , 'sans-serif'
            , 'BlinkMacSystemFont'
            , '"Segoe UI"'
            , '"Helvetica Neue"'
            , 'Arial'
            , 'sans-serif !important'
        ].join(','),
    },
});

//let MainContext = createContext<{userInfo:UserIdentity; setUserInfo: (val:UserIdentity)=>void} | null>(null);

export const Main=()=>{
    
    let [state, setState] = useState<UserInfo|null>(null);
    let auth = useContext(AuthContext);
    configureFetch(auth?.userManager||null);
    return <DNAProvider
    defaultVariants={{
        brand: "turquoise",
        scale: "medium",
        theme: "light"
    }}
    isRoot={true}
    >
        <ThemeProvider theme={theme}>
        <CssBaseline/>
        <StylesProvider injectFirst generateClassName={generateClassName}>
        <GlobalSnackbar>
            <IdentityContext.Provider value={{
                userInfo: state,
                setUserInfo:setState
            }}>
        <ApplicationLayout>
        <Router>
                    <Switch>
                        <Route path="/register">
                            <RegisterUser/>
                        </Route>
                        <Route path="/logout">
                            <Logout/>
                        </Route>
                        <Route path="/link-user-error">
                            <SelectOrganisationError/>
                        </Route>
                        <Route path="/residents">
                            <Bootstrapper/>
                        </Route>
                        <Route path="/no-access">
                            <ErrorAccessDenied/>
                        </Route>   
                        <Route path="/relogin">
                            <Relogin />
                        </Route>                     
                        <Route path="/"> 
                            <Redirect
                                to={{
                                pathname: "/residents",
                                search:window.location.hash
                                }}
                            />
                        </Route>
                  
                    </Switch>
                </Router>
        </ApplicationLayout>
        </IdentityContext.Provider>
        </GlobalSnackbar>
        </StylesProvider>
        </ThemeProvider>    
        </DNAProvider>;   
}